export default __webpack_public_path__ + "/dist/images/message-user-icon.01ef9505c81fdf0414e8e9828106a713.svg";